export const roundDecimal = (number: number, decimalPlace: number) => {
  const x = 10 ** decimalPlace;

  const natural = Math.round(number * x);
  return natural / x;
};
